import { AppData, Lightning, Log } from '@lightningjs/sdk'
import { Logger } from '../lib/logger';
import { AppSetup } from '../lib/app-setup';
import { List } from '@lightningjs/ui'
import CCItem from '../ui-elements/cc-item';
import CCItemContent from '../ui-elements/cc-item-content';
import { Column } from '@lightningjs/ui-components';

// export interface CCSettingTemplateSpec
//   extends Lightning.Component.TemplateSpec {
// Background: object;
// Title: object;
// SuggestionList: List;
// SearchListThumbItem: Grid;
// KeyboardPanel: object;
// }

// export interface CCSettingTypeConfig extends Lightning.Component.TypeConfig {
// IsPage: true;
// }

export default class CCSetting extends Lightning.Component {
  prevPage: string = 'grid';
  args: any;
  CCItems: any[] = [];
  CCItemsContent: any[] = [];
  index = 0;


  CCOptions = []

  static override _template() {
    return {
      rect: true,
      color: 0xff000000,
      w: 1920,
      h: 1080,
      Wrapper: {
        w: (w) => w,
        h: (h) => h,
        LeftWrapper: {
          w: (w) => w * 2 / 3,
          h: (h) => h,
          Title: {
            x: 80,
            y: 70,
            text: {
              text: 'Closed Captions',
              fontSize: 40,
              textColor: 0xffffffff,
            },
          },
          CCItemListWrapper: {
            w: (w) => w,
            x: 80,
            y: 200,
            CCItemList: {
              h: 1080 * 2 / 5,
              type: Column,
              scrollIndex: 9,
              items: [],
              style: {
                itemSpacing: 0
              }
            },
            CCItemListContent: {
              x: 520,
              type: Column,
              scrollIndex: 5,
              items: [],
              style: {
                itemSpacing: 0
              }
            }
          }
        },
        RightWrapper: {
          x: (w) => w * 2 / 3,
          w: (w) => w / 3,
          h: (h) => h * 2 / 5,
          rect: true,
          color: 0xffffffff,
        }
      },

    }
  };


  override _init() {
    const { ccOptions } = AppData as AppSetup
    this.CCOptions = ccOptions.userConfig
    this.CCItems = [];
    this.CCOptions.map((item, index) => {
      this.CCItems.push({
        w: 500,
        h: 90,
        marginLeft: 20,
        type: CCItem,
        item: item,
        itemSelected: false,
        itemIndex: index
      })
    })
    this.tag('CCItemList').items = this.CCItems
    this.updateContent(this.index)
    this._setState('CCItemListState')
    this.loadSampleCCSetting()
    ccOptions.updateCSS()
  }

  override _detach(): void {
    $('#subtitle-cc-sample').remove()
  }

  loadSampleCCSetting() {
    let subtitle = document.createElement('div')
    subtitle.id = 'subtitle-cc-sample'
    subtitle.setAttribute('style', 'position: absolute;top: 338px;text-align: center;width: 600px;right: 10px;z-index: 4;')
    subtitle.innerHTML = '<span>Caption Sample</span>'
    document.body.appendChild(subtitle)
  }

  override _handleRight(e: KeyboardEvent): boolean | void {
    Log.info('_handleRight: ', this._getState())
  }

  override _handleBack() {
    Log.info("_handleBack ");
    let prevPage = ''
    if (this.args.prevPage === 'player') {
      prevPage = 'player';
    }
    const { appState } = AppData as AppSetup
    const app = appState?.getApp()
    app?.handleBackNavigation(prevPage)
    Logger.processUserAction('closing CC Setting');

  }

  updateContent(index: number) {
    if(index == this.CCOptions.length-1 ) {
      this.tag('CCItemListContent').items = []
      const {ccOptions} = AppData as AppSetup
      ccOptions.resetDefault()
      this.CCOptions = ccOptions.userConfig
      return
    }
    this.CCItemsContent = [];
    const optionsValue = this.CCOptions[index].options
    let selectedIndex = 0
    optionsValue.map((option, i) => {
      if (option.isActive) {
        selectedIndex = i
      }
      this.CCItemsContent.push({
        w: 500,
        h: 90,
        marginLeft: 20,
        type: CCItemContent,
        item: option,
        itemSelected: option.isActive,
        itemIndex: i
      })
    })

    this.tag('CCItemListContent').items = []
    this.tag('CCItemListContent').items = this.CCItemsContent
    setTimeout(() => {
      this.tag('CCItemListContent').items = this.CCItemsContent
      this.tag('CCItemListContent').selectedIndex = selectedIndex
    }, 100)
  }

  updateCaption(index: number) {
    let propIndex = this.tag('CCItemList').selectedIndex
    this.tag('CCItemListContent').items.map((item, indx) => {
      if (indx == index) {
        item.itemSelected = true
      } else {
        item.itemSelected = false
      }
    })
    const list = this.CCOptions[propIndex]
    list.options.map((option, indx) => {
      if (indx == index) {
        option.isActive = true;
        list.value = option.value
      } else {
        option.isActive = false;
      }
    })
    const { ccOptions } = AppData as AppSetup
    ccOptions.saveSettings()
    ccOptions.updateCSS()
  }

  override set params(args: any) {
    this.args = args;
  }

  // onIndexChanged(indexData: any) {
  //   this.index = indexData.index
  // }

  $ItemSelected(itemIndex) {
    Log.info('CCSetting: $ItemSelected: ', this.index, this.CCItems, itemIndex)
    this.updateContent(itemIndex)
  }

  $optionSelected(itemIndex) {
    Log.info('CCSetting: $optionSelected: ', this.index, this.CCItemsContent, itemIndex)
    this.updateCaption(itemIndex)
  }

  // $onIndexHover(indexObj) {
  //   this.tag('CCItemList').setIndex(indexObj.index)
  //   //this.onIndexChanged(indexObj)
  // }

  static override _states() {
    return [
      class CCItemListState extends this {
        override _getFocused() {
          return this.tag('CCItemList');
        }
        // override _handleDown() {
        //   this.tag('CCItemList').setIndex(this.tag('CCItemList').index + 1);
        //   this.updateContent(this.tag('CCItemList').index + 1);
        // }

        // override _handleUp() {
        //   this.tag('CCItemList').setIndex(this.tag('CCItemList').index - 1);
        //   this.updateContent(this.tag('CCItemList').index - 1);
        // }
        // override _handleEnter() {
        //   this._setState("CCItemListContentState");
        //   return true
        // }
        override _handleRight() {
          Log.info('CCItemListState _handleRight')
          this._setState("CCItemListContentState");
          return true
        }
      },

      class CCItemListContentState extends this {
        override _getFocused() {
          return this.tag('CCItemListContent');
        }
        override _handleLeft() {
          this._setState("CCItemListState");
          return true
        }
      }
    ]
  }

}